import React, { useState, useEffect } from 'react'
import axios from 'axios';
import { Link } from 'react-router-dom'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import Swal from 'sweetalert2'

const config = require('../config.json')

export default function Login({ ipAddress, onLogin }) {
    const [lid, setlid] = useState('')
    const [pass, setpass] = useState('')
    const history = useHistory();
    const handleLogin = async (event) => {
        event.preventDefault()
        login();
    }

    const login = async () => {
        let ip = ipAddress
        let data = JSON.stringify({
            "lid": lid,
            "password": pass,
            "ip": ip
        });
        let axiosConfig = {
            method: 'post',
            url: `${config.baseUrl}`,
            headers: {
                'ulid': lid,
                'ip': ip,
                'Content-Type': 'application/json'
            },
            data: data
        };
        let res = await axios.request(axiosConfig)
        console.log(res.data)
        let response = res.data
        if (response.status) {
            //console.log(response.data)
            let loginData = response.data
            await setLoginData(loginData)
            onLogin(response.data)
            history.push('/dash');
        }
        else if (response.code === 30) {
            Swal.fire({
                icon: 'info',
                title: 'CaptiFx | Forex, Shares, CFDs & Commodities',
                text: response?.message
            })
        }
        else {
            Swal.fire({
                icon: 'info',
                title: 'CaptiFx | Forex, Shares, CFDs & Commodities',
                text: response?.message
            })
        }
    };
    async function setLoginData(loginData) {
        localStorage.setItem('loginData', JSON.stringify(loginData));
    }
    return (
        <div className="container-xxl">
            <div className="authentication-wrapper authentication-basic container-p-y" >
                <div className="authentication-inner py-4">
                    {/* Forgot Password */}
                    <div className="card">
                        <div className="card-body">
                            {/* Logo */}
                            <div className="app-brand justify-content-center" style={{ marginBottom: '10px' }}>
                                <Link to="/" className="app-brand-link gap-2">
                                    <span className="app-brand-logo demo">
                                        <img src="logo_d.png" style={{ height: '90px', width: 'auto' }} alt='ficon' />
                                    </span>
                                </Link>
                            </div>
                            {/* /Logo */}
                            <form id="formAuthentication" className="mb-3" onSubmit={handleLogin}>
                                <div className="mb-3">
                                    <label htmlFor="1email" className="form-label">Memebr Code</label>
                                    <input type="text" className="form-control" id="lid" name="lid" placeholder="Enter Code" value={lid} onChange={(e) => setlid(e.target.value)} />
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="e1mail" className="form-label">Password</label>
                                    <input type="password" className="form-control" id="pass" name="pass" placeholder="Password" value={pass} onChange={(e) => setpass(e.target.value)} />
                                </div>
                                <button className="btn btn-info d-grid w-100 d-flex" ><i className="fas fa-forward me-2 text-black"></i>Login </button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
